import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as L}from"../../icon-registry.js";const h=L("australia",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0.0561523 4.5H24.0001V20.5H0.0561523V4.5Z"
                fill="#10338C" />
            <path
                d="M10.4272 12.4863C10.4412 12.4722 10.4505 12.4582 10.4645 12.4442C10.4552 12.4582 10.4412 12.4722 10.4272 12.4863ZM8.83092 14.4465L9.34434 15.5178L10.4972 15.2512L9.98378 16.3178L10.9126 17.057L9.75507 17.319L9.75974 18.5073L8.83092 17.7635L7.90676 18.5073L7.91143 17.319L6.75391 17.057L7.68273 16.3178L7.16464 15.2512L8.32217 15.5178L8.83092 14.4465ZM18.0678 15.7798L18.3105 16.2898L18.8613 16.1635L18.6139 16.6734L19.0573 17.0243L18.5065 17.1459V17.7167L18.0678 17.3611L17.6244 17.7167L17.629 17.1459L17.0783 17.0243L17.5217 16.6734L17.2743 16.1635L17.8251 16.2898L18.0678 15.7798ZM15.7994 10.3529L16.0421 10.8629L16.5929 10.7366L16.3455 11.2465L16.7889 11.5974L16.2381 11.7237V12.2898L15.7994 11.9342L15.356 12.2898L15.3607 11.7237L14.8052 11.5974L15.2487 11.2465L15.0013 10.7366L15.552 10.8629L15.7994 10.3529ZM18.0678 7.25586L18.3105 7.7658L18.8613 7.63948L18.6139 8.14943L19.0573 8.5003L18.5065 8.62662V9.1927L18.0678 8.83715L17.6244 9.1927L17.629 8.62662L17.0783 8.5003L17.5217 8.14943L17.2743 7.63948L17.8251 7.7658L18.0678 7.25586ZM20.0514 9.58101L20.2942 10.0909L20.8449 9.96463L20.5975 10.4746L21.0409 10.8254L20.4902 10.9471V11.5178L20.0514 11.1623L19.608 11.5178V10.9471L19.0573 10.8254L19.5007 10.4746L19.2533 9.96463L19.8041 10.0909L20.0514 9.58101ZM18.6325 12.2898L18.8239 12.8839H19.4447L18.9406 13.2488L19.1366 13.843L18.6325 13.4734L18.1285 13.843L18.3198 13.2488L17.8204 12.8839H18.4412L18.6325 12.2898Z"
                fill="white" />
            <path
                d="M11.9487 4.5V5.93158L9.84364 7.10585H11.9487V9.88012H9.19019L11.9487 11.4146V12.486H10.7024L7.27188 10.5725V12.486H4.67678V10.2123L0.597433 12.486H0V11.0544L2.10968 9.88012H0V7.10585H2.75846L0 5.56667V4.5H1.24621L4.67678 6.40877V4.5H7.27188V6.77368L11.3559 4.5H11.9487Z"
                fill="white" />
            <path
                d="M6.72112 4.5H5.22754V7.74211H0V9.23918H5.22754V12.486H6.72112V9.23918H11.9487V7.74211H6.72112V4.5Z"
                fill="#D80027" />
            <path
                d="M7.27197 9.87988L11.9487 12.4857V11.7465L8.59753 9.87988H7.27197Z"
                fill="#0052B4" />
            <path
                d="M7.27197 9.87988L11.9487 12.4857V11.7465L8.59753 9.87988H7.27197Z"
                fill="white" />
            <path
                d="M7.27188 9.88086L11.9487 12.4867V11.7475L8.59743 9.88086H7.27188ZM3.35589 9.88086L0 11.7475V12.4867L4.67678 9.88086H3.35589Z"
                fill="#D80027" />
            <path
                d="M4.67678 7.10585L0 4.5V5.2345L3.35589 7.10585H4.67678Z"
                fill="#0052B4" />
            <path
                d="M4.67678 7.10585L0 4.5V5.2345L3.35589 7.10585H4.67678Z"
                fill="white" />
            <path
                d="M4.67678 7.10585L0 4.5V5.2345L3.35589 7.10585H4.67678ZM8.59743 7.10585L11.9487 5.2345V4.5L7.27188 7.10585H8.59743Z"
                fill="#D80027" />
        </svg>
    `),l=t`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40018"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40018)">
            <g clip-path="url(#clip0_4915_40018)">
                <path
                    d="M-5.89453 0.5H30.1055V24.5H-5.89453V0.5Z"
                    fill="#10338C" />
                <path
                    d="M9.69859 12.4794C9.71964 12.4584 9.73368 12.4373 9.75473 12.4162C9.74069 12.4373 9.71964 12.4584 9.69859 12.4794ZM7.29859 15.4198L8.07052 17.0268L9.80385 16.6268L9.03192 18.2268L10.4284 19.3355L8.68806 19.7285L8.69508 21.511L7.29859 20.3952L5.90911 21.511L5.91613 19.7285L4.17578 19.3355L5.57227 18.2268L4.79333 16.6268L6.53368 17.0268L7.29859 15.4198ZM21.1863 17.4198L21.5512 18.1847L22.3793 17.9952L22.0074 18.7601L22.674 19.2864L21.846 19.4689V20.325L21.1863 19.7917L20.5196 20.325L20.5267 19.4689L19.6986 19.2864L20.3653 18.7601L19.9933 17.9952L20.8214 18.1847L21.1863 17.4198ZM17.7758 9.2794L18.1407 10.0443L18.9688 9.85484L18.5968 10.6198L19.2635 11.1461L18.4354 11.3355V12.1847L17.7758 11.6513L17.1091 12.1847L17.1161 11.3355L16.281 11.1461L16.9477 10.6198L16.5758 9.85484L17.4039 10.0443L17.7758 9.2794ZM21.1863 4.63379L21.5512 5.3987L22.3793 5.20923L22.0074 5.97414L22.674 6.50046L21.846 6.68993V7.53905L21.1863 7.00572L20.5196 7.53905L20.5267 6.68993L19.6986 6.50046L20.3653 5.97414L19.9933 5.20923L20.8214 5.3987L21.1863 4.63379ZM24.1688 8.12151L24.5337 8.88642L25.3617 8.69695L24.9898 9.46186L25.6565 9.98817L24.8284 10.1706V11.0268L24.1688 10.4934L23.5021 11.0268V10.1706L22.674 9.98817L23.3407 9.46186L22.9688 8.69695L23.7968 8.88642L24.1688 8.12151ZM22.0354 12.1847L22.3232 13.0759H23.2565L22.4986 13.6233L22.7933 14.5145L22.0354 13.9601L21.2775 14.5145L21.5653 13.6233L20.8144 13.0759H21.7477L22.0354 12.1847Z"
                    fill="white" />
                <path
                    d="M11.9864 0.5V2.64737L8.82148 4.40877H11.9864V8.57018H7.83903L11.9864 10.8719V12.4789H10.1127L4.95482 9.60877V12.4789H1.05306V9.06842L-5.08027 12.4789H-5.97852V10.3316L-2.80659 8.57018H-5.97852V4.40877H-1.83115L-5.97852 2.1V0.5H-4.10483L1.05306 3.36316V0.5H4.95482V3.91053L11.0952 0.5H11.9864Z"
                    fill="white" />
                <path
                    d="M4.12675 0.5H1.88113V5.36316H-5.97852V7.60877H1.88113V12.4789H4.12675V7.60877H11.9864V5.36316H4.12675V0.5Z"
                    fill="#D80027" />
                <path
                    d="M4.95459 8.57031L11.9862 12.4791V11.3703L6.94757 8.57031H4.95459Z"
                    fill="#0052B4" />
                <path
                    d="M4.95459 8.57031L11.9862 12.4791V11.3703L6.94757 8.57031H4.95459Z"
                    fill="white" />
                <path
                    d="M4.95482 8.57031L11.9864 12.4791V11.3703L6.9478 8.57031H4.95482ZM-0.932902 8.57031L-5.97852 11.3703V12.4791L1.05306 8.57031H-0.932902Z"
                    fill="#D80027" />
                <path
                    d="M1.05306 4.40877L-5.97852 0.5V1.60175L-0.932902 4.40877H1.05306Z"
                    fill="#0052B4" />
                <path
                    d="M1.05306 4.40877L-5.97852 0.5V1.60175L-0.932902 4.40877H1.05306Z"
                    fill="white" />
                <path
                    d="M1.05306 4.40877L-5.97852 0.5V1.60175L-0.932902 4.40877H1.05306ZM6.9478 4.40877L11.9864 1.60175V0.5L4.95482 4.40877H6.9478Z"
                    fill="#D80027" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40018">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.89453 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,p=L("australia_rounded",l),M=L("AUD",l);export{M as AUD,h as Australia,p as AustraliaRounded};
